import React from "react";
import { loadPreferenceServer, savePreferenceServer } from "../docuclipper/api";
import { lsGetItem, lsSetItem } from "../LocalStorageWrapper";

export const loadPreference = async (key: string, defaultValue: any) => {
  const fullKey = `docuclipper.uiState.${key}`;
  const item = lsGetItem(fullKey);
  if (item) {
    return item;
  }
  try {
    const preference = await loadPreferenceServer({ key: fullKey });
    return preference.value || defaultValue;
  } catch (err) {
    return defaultValue;
  }
};

export const savePreference = async (key: string, value: string) => {
  const fullKey = `docuclipper.uiState.${key}`;
  lsSetItem(fullKey, value);
  try {
    await savePreferenceServer({ key: fullKey, value });
  } catch (err) {}
};

// Hook
export function useLocalStorage(key, initialValue) {
  // State to store our value
  // Pass initial state function to useState so logic is only executed once
  const [storedValue, setStoredValue] = React.useState(() => {
    try {
      // Get from local storage by key
      const item = window.localStorage.getItem(key);
      // Parse stored json or if none return initialValue
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      // If error also return initialValue
      // console.log(error);
      return initialValue;
    }
  });
  // Return a wrapped version of useState's setter function that ...
  // ... persists the new value to localStorage.
  const setValue = (value) => {
    try {
      // Allow value to be a function so we have same API as useState
      const valueToStore =
        value instanceof Function ? value(storedValue) : value;
      // Save state
      setStoredValue(valueToStore);
      // Save to local storage
      window.localStorage.setItem(key, JSON.stringify(valueToStore));
    } catch (error) {
      // A more advanced implementation would handle the error case
      // console.log(error);
    }
  };
  return [storedValue, setValue];
}
